
import React from 'react';
import CheckBetLayout1 from './CheckBetLayout1';
import CheckBetLayout2 from '../my-bets-layout-2/checkbet-layout-2/CheckBetLayout2';
import { getConfiguration } from '../../utils';

function CheckBet(props) {
    const conf = getConfiguration();
    const showOldLayout = conf.mbt == null || conf.mbt === 'V1';
    return (
        <>
            {showOldLayout ?
                <CheckBetLayout1 {...props} />
                :
                <CheckBetLayout2 {...props} />
            }
        </>
    );
}

export default CheckBet;